<template>
<w-settings-detail :title="title" :menu="menu">
  <w-logical-group-config-view slot="activeView" v-show="!isEditMode" :visible="!isEditMode" :tree-data="treeData" @change-edit-mode="onChangeEditMode" />
  <w-logical-group-tree-view slot="activeView" v-show="isEditMode" :visible="isEditMode" :tree-data="treeData" @change-edit-mode="onChangeEditMode" @change-tree-data="loadData"/>
</w-settings-detail>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import logicalGroupApi from '@/api/settings/common/logical-group';
import WLogicalGroupConfigView from './LogicalGroupConfigView';
import WLogicalGroupTreeView from './LogicalGroupTreeView';

export default {
  name: 'WLogicalGroupSettings',
  components: {
    WSettingsDetail,
    WSettingsContentTemplate,
    WLogicalGroupConfigView,
    WLogicalGroupTreeView,
  },
  props: {
    title: String,
  },
  data() {
    return {
      menu: [],
      treeData: null,
      isEditMode: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      logicalGroupApi.getLogicalGroupTree(true).then((res) => {
        if (res.data.success && !isEmpty(res.data)) {
          this.treeData = res.data.data;
        }
      });
    },
    onChangeEditMode(isEditMode) {
      this.isEditMode = isEditMode;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/LogicalGroupSettings/index.vue